// /tools — the free tools
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Seo from '../site/Seo';
import CtaBand from '../site/CtaBand';
import { TOOLS } from './toolData';
import '../useCases/useCases.css';

export default function ToolsIndex() {
  return (
    <>
      <Seo
        title="Free YouTube tools: timestamps, transcripts, summaries, chapter checker | Bumpups"
        description="Free tools for YouTube videos: generate timestamps and chapters, get a transcript as TXT, SRT or VTT, summarize a video, and check why chapters aren't showing."
      />
      <section className="uc-hero mk-hero-bg">
        <div className="mk-container">
          <p className="mk-eyebrow">Free tools</p>
          <h1 className="mk-h1 uc-title">Free tools for YouTube videos</h1>
          <p className="mk-lead">Timestamps, transcripts and summaries for any YouTube video, and a checker that tells you why your chapters aren’t showing.</p>
        </div>
      </section>
      <section className="mk-section mk-section--tight" style={{ paddingTop: 0 }}>
        <div className="mk-container">
          <div className="mk-grid mk-grid--2">
            {TOOLS.map(t => (
              <Link key={t.slug} to={`/tools/${t.slug}`} className="mk-card uc-card">
                <span className="mk-icon"><FontAwesomeIcon icon={t.icon} /></span>
                <h2 className="mk-h3">{t.label}</h2>
                <p className="mk-text">{t.summary}</p>
                <span className="uc-card-more">Open the tool →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
